import { c as _c } from "react/compiler-runtime";
import { env } from '@cc-shopping/platform-env';
import { isAmexOffer } from '@cc-shopping/utils/offers';
import { Box, Link, Typography } from '@mui/material';
import { RECOMMENDED_CREDIT_LEARN_MORE_PATH, RECOMMENDED_CREDIT_TOOLTIP_TEXT } from 'src/features/approval-odds/constants';
import { getOddsLabel } from 'src/features/approval-odds/utils';
import { DriverValueTooltipLegacy } from '../DriverValueTooltipLegacy';
import type { DriverProps } from '../types';
const tooltipLinkURL = `${env.NEXT_PUBLIC_NW_URL}${RECOMMENDED_CREDIT_LEARN_MORE_PATH}`;
export function RecommendedCreditScore(t0) {
  const $ = _c(15);
  const {
    creditCardOffer,
    isMonetizing: t1,
    segmentActionSection
  } = t0;
  const isMonetizing = t1 === undefined ? true : t1;
  const {
    details: t2
  } = creditCardOffer;
  const {
    creditScore: t3
  } = t2;
  const {
    min,
    max
  } = t3;
  const isAmexCard = isAmexOffer(creditCardOffer);
  let t4;
  if ($[0] !== max || $[1] !== min) {
    t4 = getOddsLabel(min, max);
    $[0] = max;
    $[1] = min;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const oddsLabel = t4;
  const label = isAmexCard ? oddsLabel : `${min}-${max} (${oddsLabel})`;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      fontSize: "inherit"
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      whiteSpace: "nowrap"
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      color: "common.black"
    };
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Typography variant="textSmall" sx={t7}>{RECOMMENDED_CREDIT_TOOLTIP_TEXT}{" "}<Link target="_blank" href={tooltipLinkURL} rel="noopener">{" "}Read more.</Link></Typography>;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      position: "relative",
      top: "3px"
    };
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== creditCardOffer.id || $[9] !== isMonetizing || $[10] !== segmentActionSection) {
    t10 = <Box component="span" sx={t6}>{"\xA0"}<DriverValueTooltipLegacy text={t8} ariaLabel="Recommended Credit Score Details" driverKey="reccreditscore" segmentActionSection={segmentActionSection} isMonetizing={isMonetizing} offerId={creditCardOffer.id} maxWidth={294} containerStyles={t9} /></Box>;
    $[8] = creditCardOffer.id;
    $[9] = isMonetizing;
    $[10] = segmentActionSection;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== label || $[13] !== t10) {
    t11 = <Typography component="span" variant="text" sx={t5}>{label}{t10}</Typography>;
    $[12] = label;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  return t11;
}